<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-modal
        id="modal-Editor"
        centered
        ok-only
        ok-title="ثبت"
        title="افزودن کد HTML"
        @ok.prevent="customButtonClick"
    >
      <b-row>
        <b-col cols="12">
          <span class="d-block mx-1 mb-1">کد HTML خود را در اینجا قرار دهید</span>
          <b-form-textarea v-model="rawHTML" rows="10" dir="ltr" />
        </b-col>
      </b-row>
    </b-modal>

    <b-row>
      <b-col cols="12">
        <b-card>
          <h4>اطلاعات کلی</h4>

          <TagPicker v-model="defaultData.tagIds" label="تگ‌های کارت دوره" />
          <TagPicker v-model="defaultData.sliderTagIds" label="تگ‌های اسلایدر بالای صفحه" />

          <b-media class="my-2">
            <template #aside>
              <b-avatar
                  ref="previewEl"
                  :src="base64ImageSrc"
                  size="300px"
                  rounded
              />
            </template>

            <div class="d-flex flex-wrap mt-1">
              <b-button variant="primary" @click="$refs.refInputEl.click()">
                <input
                    ref="refInputEl"
                    type="file"
                    accept="image/*"
                    class="d-none"
                    @change="makeBase64Pic"
                >
                <span class="d-none d-sm-inline">+ عکس</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>

              <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="deleteProductPic"
              >
                <span class="d-none d-sm-inline">حذف</span>
                <feather-icon icon="TrashIcon" class="d-inline d-sm-none" />
              </b-button>
            </div>
          </b-media>

          <b-form @submit.prevent="createProduct">
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group label="عنوان" label-for="Title">
                  <b-form-input id="Title" v-model="defaultData.title" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group label="وضعیت" label-for="user-status">
                  <v-select
                      v-model="defaultData.isFree"
                      :options="isFreeOptions"
                      :reduce="item => item.value"
                      :clearable="false"
                      input-id="user-status"
                      label="label"
                  />
                </b-form-group>
              </b-col>

              <b-col v-if="!defaultData.isFree" cols="12" md="4">
                <b-form-group label="قیمت (تومان)" label-for="price">
                  <b-form-input
                      id="price"
                      v-model="defaultData.price"
                      type="number"
                      min="0"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group label="موجودیت" label-for="isAvailable">
                  <v-select
                      v-model="defaultData.available"
                      :options="isAvailableOptions"
                      :reduce="item => item.value"
                      :clearable="false"
                      input-id="isAvailable"
                      label="label"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group label="قیمت قبلی (خط خورده)" label-for="beforeDiscount">
                  <b-form-input
                      id="beforeDiscount"
                      v-model="defaultData.beforeDiscount"
                      type="number"
                      min="0"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <div class="product-categories mt-2">
                  <span class="filter-title">نمایش محصول در باندل</span>
                  <b-form-checkbox
                      v-model="defaultData.showOnlyInBundle"
                      name="showOnlyInBundle"
                      switch
                      inline
                  />
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group label="سوتیتر" label-for="subtitle">
                  <b-form-input id="subtitle" v-model="defaultData.subtitle" />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group class="mb-2" label="توضیحات" label-for="product-content">
                  <ckEditorMain
                      ref="editorContent"
                      :defaultContent="defaultData.description"
                      @getEditorContent="setEditorContent"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group label="انتخاب نوع محصول" label-for="type">
                  <v-select
                      v-model="defaultData.type"
                      :options="[{ label: 'دوره', value: 1 }]"
                      :reduce="item => item.value"
                      :clearable="false"
                      disabled
                      input-id="type"
                      label="label"
                  />
                </b-form-group>
              </b-col>

              <b-col v-if="courseCategories !== null" cols="12" md="4">
                <b-form-group label="دسته‌بندی دوره" label-for="productCategoryId">
                  <v-select
                      v-model="defaultData.productCategoryId"
                      :options="courseCategories"
                      label="name"
                      :reduce="item => item.productCategoryId"
                      :clearable="false"
                      input-id="productCategoryId"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4">
                <b-form-group label="دسته‌بندی خدمات" label-for="serviceCategoryType">
                  <v-select
                      v-model="defaultData.serviceCategoryType"
                      :options="serviceCategoryTypes"
                      label="label"
                      :reduce="item => item.value"
                      :clearable="false"
                      input-id="serviceCategoryType"
                      placeholder="انتخاب دسته‌بندی خدمات"
                  >
                    <template #no-options>گزینه‌ای پیدا نشد</template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button
                type="submit"
                :disabled="overlay || Number(defaultData.type) < 1"
                variant="primary"
                class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              ثبت
            </b-button>
          </b-form>
        </b-card>

        <b-card class="blog-edit-wrapper mt-2">
          <h4 class="mb-2">سئو</h4>

          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="عنوان سئو" label-for="seoTitle">
                <b-form-input
                    id="seoTitle"
                    v-model="seoData.seoTitle"
                    maxlength="60"
                    placeholder="عنوانی کوتاه و مرتبط با محتوای دوره"
                />
              </b-form-group>
              <div
                  class="small"
                  :class="{ 'text-danger': seoData.seoTitle.length > 60 }"
              >
                تعداد کاراکترهای مجاز
                <span>{{ seoData.seoTitle.length }}</span>
                <span class="text-secondary">/ 60</span>
              </div>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="آدرس صفحه" label-for="seoUrl">
                <b-input-group>
                  <b-form-input
                      id="seoUrl"
                      v-model="seoData.seoUrl"
                      dir="ltr"
                      placeholder="course-page-url"
                  />
                  <b-input-group-append>
                    <b-button variant="outline-primary" @click="copySeoUrl">
                      کپی
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <small class="text-muted">آدرس انگلیسی و بدون فاصله پیشنهاد می‌شود.</small>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="توضیحات متا" label-for="seoDescription">
                <b-form-textarea
                    id="seoDescription"
                    v-model="seoData.seoDescription"
                    rows="3"
                    maxlength="300"
                    placeholder="خلاصه‌ای روشن و جذاب از محتوای این دوره بنویسید."
                />
              </b-form-group>
              <div
                  class="small"
                  :class="{ 'text-danger': seoData.seoDescription.length > 300 }"
              >
                تعداد کاراکترهای مجاز
                <span>{{ seoData.seoDescription.length }}</span>
                <span class="text-secondary">/ 300</span>
              </div>
            </b-col>

            <b-col cols="12">
              <b-form-group label="کلمات کلیدی" label-for="seoKeywords">
                <b-form-textarea
                    id="seoKeywords"
                    v-model="seoData.seoKeywords"
                    rows="2"
                    maxlength="300"
                    placeholder="کلمات کلیدی را با ویرگول از یکدیگر جدا کنید."
                />
              </b-form-group>
              <div
                  class="small"
                  :class="{ 'text-danger': seoData.seoKeywords.length > 300 }"
              >
                تعداد کاراکترهای مجاز
                <span>{{ seoData.seoKeywords.length }}</span>
                <span class="text-secondary">/ 300</span>
              </div>
            </b-col>

            <b-col cols="12">
              <b-card class="mt-1" border-variant="light">
                <h5 class="mb-2">نحوه نمایش در گوگل</h5>
                <div class="serp-preview p-3 d-none d-lg-flex flex-column align-items-start">
                  <div class="serp-title">
                    <h4 class="mb-1">{{ seoPreviewTitle }}</h4>
                  </div>
                  <div class="serp-url mb-1" dir="ltr">
                    <span>{{ seoPreviewUrl }}</span>
                  </div>
                  <div class="serp-description">
                    <p class="mb-0">{{ seoPreviewDescription }}</p>
                  </div>
                </div>

                <div class="serp-preview p-3 d-flex d-lg-none flex-column align-items-start">
                  <div class="serp-title">
                    <h6 class="mb-1">{{ seoPreviewTitle }}</h6>
                  </div>
                  <div class="serp-url mb-1 small" dir="ltr">
                    <span>{{ seoPreviewUrl }}</span>
                  </div>
                  <div class="serp-description small">
                    <span>{{ seoPreviewDescription }}</span>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import TagPicker from "@/views/components/TagPicker.vue";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BMedia,
  BAvatar,
  BOverlay,
  BModal,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import {
  ProductCategoryPropertyGetByCategoryIdRequest,
  ProductCreateRequest,
  ProductCourseGetAllRequest,
  ProductGetAllRequest,
  ProductCategoryGetAllProductCategoriesRequest,
  ProductCategoryGetAllCourseCategoriesRequest,
} from "@/libs/Api/Product";
import NewCategoryProperty from "@/views/apps/e-commerce/e-commerce-add/NewCategoryProperty";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ckEditorMain from "@/views/components/ckEditorMain";
import { PsychologicalTestGetLightListRequest } from "@/libs/Api/Test";
import Helper from "@/libs/Helper";

export default {
  title: "افزودن محصول - پنل ادمین بنفشه باقری",
  name: "ECommerceAdd",
  components: {
    TagPicker,
    BFormCheckbox,
    NewCategoryProperty,
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BMedia,
    BAvatar,
    BOverlay,
    BModal,
    vSelect,
    ckEditorMain,
  },
  data() {
    return {
      overlay: false,
      propertiesData: [],
      defaultData: {
        tagIds: [],
        sliderTagIds: [],
        isDeleted: false,
        productId: 0,
        parentId: 0,
        title: "",
        description: "",
        productCategoryId: null,
        courseScheduleId: 0,
        courseId: null,
        price: "",
        isFree: true,
        type: 1,
        imageFile: "",
        fileData: null,
        subtitle: "",
        beforeDiscount: "",
        trailerFile: "",
        viewCounts: 0,
        properties: [],
        available: false,
        psychologicalTestId: null,
        serviceCategoryType: 1,
        showOnlyInBundle: false,
        productInfos: [
          { title: "", icon: "" },
          { title: "", icon: "" },
          { title: "", icon: "" },
        ],
      },
      seoData: {
        seoTitle: "",
        seoUrl: "",
        seoDescription: "",
        seoKeywords: "",
      },
      showHTML: false,
      snowOption: {
        theme: "snow",
        modules: {
          toolbar: "#toolbar",
        },
      },
      rawHTML: "",
      isFreeOptions: [
        { label: "رایگان", value: true },
        { label: "پولی", value: false },
      ],
      serviceCategoryTypes: [
        { label: "بهبود رابطه با پارتنر", value: 1 },
        { label: "پیش‌گیری از خیانت", value: 2 },
        { label: "جذابیت‌های زنانه در رابطه عاطفی", value: 3 },
        { label: "فرزندپروری", value: 4 },
        { label: "آموزش‌های سواد رابطه جنسی", value: 5 },
      ],
      isAvailableOptions: [
        { label: "موجود", value: true },
        { label: "ناموجود", value: false },
      ],
      base64ImageSrc: null,
      productCategories: null,
      courseCategories: null,
      categoryProperties: null,
      courses: null,
      productCourses: null,
      productTests: [],
    };
  },
  computed: {
    defaultDataProductCategoryId() {
      return this.defaultData.productCategoryId;
    },
    defaultDataProductType() {
      return this.defaultData.type;
    },
    defaultDataImageFile() {
      return this.defaultData.imageFile;
    },
    baseUrl() {
      return String(Helper.baseUrl || "").replace(/\/+$/, "");
    },
    seoPreviewTitle() {
      return this.seoData.seoTitle || this.defaultData.title || "عنوان صفحه";
    },
    seoPreviewUrl() {
      const slug = this.normalizeSeoUrl(this.seoData.seoUrl || this.defaultData.title);
      return `${this.baseUrl}/${slug ? `${slug}/` : ""}`;
    },
    seoPreviewDescription() {
      return this.seoData.seoDescription || "توضیحات متای صفحه در این قسمت نمایش داده می‌شود.";
    },
  },
  watch: {
    defaultDataProductCategoryId(newValue) {
      if (newValue) {
        this.getCategoryProperties(newValue);
      }
    },
  },
  async created() {
    await this.getAllProductCategories();
    await this.getAllCourseCategories();
    await this.getAllCourses();
    await this.getProductCourses();
    await this.getProductTests();
  },
  methods: {
    normalizeSeoUrl(value) {
      return String(value || "")
          .trim()
          .toLowerCase()
          .replace(/[\s_]+/g, "-")
          .replace(/[^\w\-آ-ی]/g, "")
          .replace(/-+/g, "-")
          .replace(/^-|-$/g, "");
    },
    async copySeoUrl() {
      const value = this.seoPreviewUrl;
      try {
        await navigator.clipboard.writeText(value);
        this.showToast("عملیات موفق", "آدرس سئو کپی شد.");
      } catch (error) {
        const input = document.createElement("textarea");
        input.value = value;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.showToast("عملیات موفق", "آدرس سئو کپی شد.");
      }
    },
    showToast(title, text, variant = "success", icon = "CheckIcon") {
      this.$toast({
        component: ToastificationContent,
        position: "bottom-center",
        props: {
          title,
          icon,
          variant,
          text,
        },
      });
    },
    async createProduct() {
      if (this.overlay) {
        return;
      }

      this.defaultData.productInfos = null;
      this.overlay = true;

      const {
        seoTitle,
        seoUrl,
        seoDescription,
        seoKeywords,
      } = this.seoData;

      const payload = {
        ...this.defaultData,
      };

      delete payload.seoTitle;
      delete payload.seoUrl;
      delete payload.seoDescription;
      delete payload.seoKeywords;

      const productCreateRequest = new ProductCreateRequest(this);
      productCreateRequest.setParams(payload);

      try {
        await productCreateRequest.fetch(
            content => {
              this.overlay = false;
              if (content && content.isSuccess === false) {
                this.showToast(
                    "عملیات ناموفق",
                    content.errorMessage || "ثبت محصول انجام نشد.",
                    "danger",
                    "CloseIcon"
                );
                return;
              }
              this.showToast("عملیات موفق", "عملیات انجام شد.");
              this.$router.push({ name: "apps-e-commerce-shop" });
            },
            error => {
              this.overlay = false;
              console.error(error);
              this.showToast(
                  "عملیات ناموفق",
                  error?.response?.data?.errorMessage ||
                  error?.response?.data?.message ||
                  error?.message ||
                  "ثبت محصول انجام نشد.",
                  "danger",
                  "CloseIcon"
              );
            }
        );
      } catch (error) {
        this.overlay = false;
        console.error(error);
        this.showToast(
            "عملیات ناموفق",
            error?.message || "ثبت محصول انجام نشد.",
            "danger",
            "CloseIcon"
        );
      }
    },
    async getAllProductCategories() {
      this.overlay = true;
      const params = {
        pageNumber: 0,
        count: 0,
      };
      const request = new ProductCategoryGetAllProductCategoriesRequest(this);
      request.setParams(params);

      try {
        await request.fetch(
            content => {
              this.productCategories = content.productCategories || [];
              this.overlay = false;
            },
            error => {
              console.error(error);
              this.overlay = false;
            }
        );
      } catch (error) {
        console.error(error);
        this.overlay = false;
      }
    },
    async getAllCourseCategories() {
      this.overlay = true;
      const params = {
        pageNumber: 0,
        count: 0,
      };
      const request = new ProductCategoryGetAllCourseCategoriesRequest(this);
      request.setParams(params);

      try {
        await request.fetch(
            content => {
              this.courseCategories = content.productCategories || [];
              this.overlay = false;
            },
            error => {
              console.error(error);
              this.overlay = false;
            }
        );
      } catch (error) {
        console.error(error);
        this.overlay = false;
      }
    },
    async getProductTests() {
      this.overlay = true;
      const request = new PsychologicalTestGetLightListRequest(this);

      try {
        await request.fetch(
            content => {
              this.overlay = false;
              this.productTests = content || [];
            },
            error => {
              this.overlay = false;
              console.error(error);
            }
        );
      } catch (error) {
        this.overlay = false;
        console.error(error);
      }
    },
    async getCategoryProperties(param) {
      this.overlay = true;
      const request = new ProductCategoryPropertyGetByCategoryIdRequest(this);
      request.setId(param);

      try {
        await request.fetch(
            content => {
              this.categoryProperties = content || [];
              this.defaultData.properties = this.categoryProperties.map(element => ({
                name: element.name,
                val: "",
                categoryPropertyId: element.categoryPropertyId,
              }));
              this.overlay = false;
            },
            error => {
              console.error(error);
              this.overlay = false;
            }
        );
      } catch (error) {
        console.error(error);
        this.overlay = false;
      }
    },
    readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
          const result = String(reader.result || "");
          resolve(result.includes(",") ? result.split(",")[1] : result);
        };
        reader.readAsDataURL(file);
      });
    },
    async getAllCourses() {
      this.overlay = true;
      const params = {
        pageNumber: 0,
        searchCommand: "",
        count: 0,
      };
      const request = new ProductCourseGetAllRequest(this);
      request.setParams(params);

      try {
        await request.fetch(
            content => {
              this.courses = content.courses || [];
              this.overlay = false;
            },
            error => {
              this.overlay = false;
              console.error(error);
            }
        );
      } catch (error) {
        this.overlay = false;
        console.error(error);
      }
    },
    async getProductCourses() {
      this.overlay = true;
      const params = {
        categoryId: 0,
        searchByTitle: "",
        pageNumber: 0,
        count: 0,
        type: 1,
        isFree: "",
        showOnlyInBundle: "",
      };
      const request = new ProductGetAllRequest(this);
      request.setParams(params);

      try {
        await request.fetch(
            content => {
              this.productCourses = content.products || [];
              this.overlay = false;
            },
            error => {
              this.overlay = false;
              console.error(error);
            }
        );
      } catch (error) {
        this.overlay = false;
        console.error(error);
      }
    },
    async makeBase64Pic(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      this.base64ImageSrc = URL.createObjectURL(file);
      this.defaultData.imageFile = await this.readAsDataURL(file);
    },
    async makeBase64(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      this.defaultData.trailerFile = await this.readAsDataURL(file);
    },
    deleteProductPic() {
      this.defaultData.imageFile = "";
      this.base64ImageSrc = null;
      if (this.$refs.refInputEl) {
        this.$refs.refInputEl.value = "";
      }
    },
    customButtonClick() {
      this.showHTML = !this.showHTML;
      const editor = document.querySelector(".ql-editor");
      if (!editor) {
        return;
      }

      if (editor.classList.contains("d-none")) {
        this.defaultData.description = this.rawHTML;
        editor.classList.remove("d-none");
      } else {
        this.rawHTML = this.defaultData.description || "";
        editor.classList.add("d-none");
      }
    },
    setEditorContent(content) {
      this.defaultData.description = content;
    },
  },
};
</script>

<style scoped>
.serp-preview {
  width: 100%;
  max-width: 760px;
  direction: rtl;
  text-align: right;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  overflow-wrap: anywhere;
}

.serp-title h4,
.serp-title h6 {
  color: #1a0dab;
  font-weight: 400;
}

.serp-url {
  color: #006621;
  overflow-wrap: anywhere;
}

.serp-description {
  color: #4d5156;
  line-height: 1.7;
}

.serp-description p {
  margin: 0;
}
</style>
